import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


/**
 * 下载政策模版
 * @returns {Promise}
 */

export function downloadPolicyTemplate() {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}

/**
 * 导入政策
 */
export function importPolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/policyImport`,
        method: 'post',
        data
    })
}

/**
 * 政策列表
 */
export function getPolicyList(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 删除政策
 */
export function deletePolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}

/**
 * 发布政策
 */
export function publishPolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/publish`,
        method: 'post',
        data
    })
}

/**
 * 下架政策
 */
export function unpublishPolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/cancelPublish`,
        method: 'post',
        data
    })
}

/**
 * 新增政策
 */
export function addPolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

/**
 * 更新政策
 */
export function updatePolicy(data) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

/**
 * 获取政策详情
 */
export function getPolicyDetail(id) {
    return request({
        url: `/${systemConfig.policyPrefix}/policyInfo/gl/v1.0.0/detail/${id}`,
        method: 'get'
    })
}